import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useI18n } from '../../contexts/I18nContext';
import { MoonIcon, SunIcon } from './icons';

/**
 * One icon button for the top bar: shows the mode you would switch *to*,
 * the way a light switch shows the position it is not in.
 */
export const ThemeToggleButton: React.FC = () => {
  const { isDark, toggleTheme } = useTheme();
  const { t } = useI18n();
  const label = isDark ? t('theme.switchToLight') : t('theme.switchToDark');

  return (
    <button
      type="button"
      className="topbar-icon-btn theme-toggle-btn"
      onClick={toggleTheme}
      aria-label={label}
      aria-pressed={isDark}
      title={label}
      data-testid="theme-toggle"
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </button>
  );
};
